import { Loader2 } from "lucide-react";

import { cn } from "@/utils/cn";

/**
 * docs/ui/design-system.md §11 Spinner sizes: inline (16px, inside a Button/
 * Input — Button already has its own inline usage, see ui/button.tsx),
 * standalone (24px, a small content region), full-view (32px, page-level).
 */
const SPINNER_SIZE_CLASSES = {
  inline: "h-4 w-4",
  standalone: "h-6 w-6",
  "full-view": "h-8 w-8",
} as const;

export type SpinnerSize = keyof typeof SPINNER_SIZE_CLASSES;

interface SpinnerProps {
  size?: SpinnerSize;
  /** Accessible label — `role="status"` announces this, not a purely
   * decorative animation with no text alternative (design-system.md §11). */
  label?: string;
  className?: string;
}

export function Spinner({ size = "standalone", label = "Loading", className }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center justify-center">
      <Loader2
        className={cn(SPINNER_SIZE_CLASSES[size], "animate-spin text-primary", className)}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
